module.exports = __webpack_public_path__ + "img/tuiguang1.e3fe80c9.png";